import React from 'react';
import { DASHBOARD_BACKGROUND_SCRIPT_MODULE } from '@atlassian/jira-forge-ui-constants';
import { LazyIframe } from '@atlassian/jira-forge-ui-iframe-generic';
import type {
	DashboardBackgroundScriptModule,
	DashboardBackgroundScriptExtensionData,
	ExtensionNextProps,
	DashboardBackgroundScript,
} from '@atlassian/jira-forge-ui-types';
import { isCustomUIExtension } from '@atlassian/jira-forge-ui-utils-internal/src/utils/extension';
import { InvisibleDiv } from '../../common/ui/invisible-div';
import type { LazyProps } from '../../types';

type Props = ExtensionNextProps<
	DashboardBackgroundScriptModule,
	DashboardBackgroundScript,
	DashboardBackgroundScriptExtensionData
>;

export const AsyncDashboardBackgroundScript = (props: LazyProps<Props>) => {
	const { extensionData, ...restProps } = props;

	const extraProps = {
		module: DASHBOARD_BACKGROUND_SCRIPT_MODULE,
		extensionData: {
			...extensionData,
			type: DASHBOARD_BACKGROUND_SCRIPT_MODULE,
		},
	};

	if (!isCustomUIExtension(props.extension)) return null;

	return (
		<InvisibleDiv>
			<LazyIframe {...restProps} {...extraProps} />
		</InvisibleDiv>
	);
};
